<template>
  <div class="common-card messages-list-wrapper">
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder text-nowrap mb-0">
            <font-awesome-icon class="mr-1" icon="fa-solid fa-bell" />
            <!-- 管理 -->
            訊息記錄
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋"
          />
          <b-button class="mobile-w100" :to="{ name: 'message-create' }" v-if="ability.can('create', 'messages')">
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增訊息</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refMessageListTable"
          class="position-relative"
          :items="fetchMessages"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(is_read)="data">
            <feather-icon
              v-if="data.item.is_read"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>
            <!-- Column: type -->
          <template #cell(user_type)="data">
            {{data.item.user_type && data.item.user_type.type}}
            <!-- {{ userTypeOptions && userTypeOptions.length > 0 &&
            userTypeOptions.filter(ele => ele.id == data.item.user_type_id)[0].type }} -->
          </template>

          <template #cell(users)="data">
            <span v-if="data.item.users && data.item.users.length">
              <span v-for="(user, index) in data.item.users" :key="`user-${index}`">
                {{ user.name_cn }}<br v-if="index < data.item.users.length - 1">
              </span>
            </span>
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                messagesList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('update', 'messages')"
                :to="{
                  name: 'message-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'messages')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除資料</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useMessagesList from "./useMessagesList";
import messageStoreModule from "../messageStoreModule";
import { getDateTime } from "@/libs/helper";
import { EventBus } from "@/main";


export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {};
  },
  methods: {
    getDateTime,
    removeItem(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("message/deleteMessage", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  activated() {
    // 當列表頁重新被激活（例如從編輯/查看頁返回）時，重新抓取訊息
    this.refetchData();
  },
  created() {
    // 監聽全域事件：當任一處標記訊息為已讀成功時，刷新列表
    EventBus.$on('messages:read-updated', this.refetchData)
  },
  beforeDestroy() {
    EventBus.$off('messages:read-updated', this.refetchData)
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "message";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, messageStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchMessages,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      messagesList,
      refMessageListTable,
      ability,
      refetchData,
      userTypeOptions,
    } = useMessagesList();

    return {
      fetchMessages,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      messagesList,
      refMessageListTable,
      ability,
      refetchData,
      userTypeOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 100px;
}


// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
@media (min-width: 540px) {
  .messages-list-wrapper {
    .sticky-column {
      &:nth-child(1) {
        width: 120px!important;
        min-width: 120px!important;
        max-width: 120px!important;
      }
      &:nth-child(2) {
        left: 120px;
        width: 100px!important;
        min-width: 100px!important;
        max-width: 100px!important;
      }
      &:nth-child(3) {
        left: 220px;
      }
    }
  }
}
</style>
